<div class="buyer-layout-wrap bg-light-grey">
    <app-header></app-header>
    <router-outlet></router-outlet>
</div>
